






































































import { Component, Vue, Prop } from 'vue-property-decorator'
//import ViewLink from '@/components/viewLink.vue'

@Component({
  components: {}
})
export default class UnitRiskView extends Vue {
  public name = 'UnitRiskView'
  public collapseNames: string[] = ['unitRisk', 'eventRisk']
  @Prop({ default: null })
  public riskList: any[] = []
  @Prop({ default: null })
  public eventList: any[] = []
}
